import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetRegisterDto } from '../../../common/spdCore/autogenerated/spdApiClient';

import { Selector, Option } from './Selector';

export interface RegisterSelectorProps {
  readOnly?: boolean;
  value?: string;
  placeholder?: string;
  className?: string;
  onChange?: (option: Option) => void;
  clearable?: boolean;
  addAll?: boolean;
}

export default (props: RegisterSelectorProps) => {
  const spd = useSpdCore();
  const [registers, setRegisters] = useState<GetRegisterDto[]>([]);
  const [name, setName] = useState<string>();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (props.value) {
      spd.registers
        .get(props.value || '')
        .then(register => {
          setName(register.name || '');
        })
        .catch(error =>
          console.log(`Wystąpił problem z pobraniem rejestrów. ${error}`),
        );
    } else {
      setName('');
    }
  }, [props.value, spd.registers]);

  useEffect(() => {
    let mounted = true;
    spd.registers
      .getAll()
      .then(register => {
        if (mounted) {
          setRegisters(
            register.sort((a, b) => (a.name || '').localeCompare(b.name || '')),
          );
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem rejestrów. ${error}`),
      );

    return () => {
      mounted = false;
    };
  }, [spd.registers]);

  const provider = async (text: string) => {
    const values = registers.filter(v => {
      const name = v.name || '';
      return name.toLocaleLowerCase().includes(text.toLocaleLowerCase());
    });

    return [
      ...(props.addAll ? [{ label: 'Wybierz rejestr', value: 'All' }] : []),
      ...values.map(v => {
        const userNames = v.name;
        return {
          label: userNames || '',
          value: v.id,
        };
      }),
    ];
  };

  return ready ? (
    <Selector
      uniqueKey={'registers-' + JSON.stringify(registers)}
      className={props.className}
      readOnly={props.readOnly}
      creatable={false}
      placeholder={props.placeholder || 'Wskaż...'}
      provider={provider}
      value={name}
      onChange={props.onChange}
      clearable={props.clearable}
    />
  ) : (
    <Skeleton />
  );
};
